import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardLayout from "frontend_common/src/layouts/DashboardLayout";
import NotFoundPage from "frontend_common/src/components/NotFound";
import Login from "frontend_common/src/components/Login";
import store  from '../store'
import i18n from "../i18n";
import List from "../components/List";
import UserForm from "../components/UserForm";
import Transfer from "../components/Transfer";

Vue.use(VueRouter)

let loginPage = {
  path: '/login',
  name: i18n.t('routes.login'),
  component: Login,
  props: { title: 'POS admin portal' },
  meta: { loginPage: true, nonRequiresAuth: true }
}

const routes = [
  loginPage,
  {
    path: "/",
    component: DashboardLayout,
    props: { title: 'POS admin portal' },
    redirect: "list",
    name: "home",
    children: [
      {
        path: "list",
        name: i18n.t('routes.list'),
        component: List
      },
      {
        path: "add",
        name: i18n.t('routes.add'),
        component: UserForm
      },
      {
        path: "cash-deposit",
        name: i18n.t('routes.cash-deposit'),
        component: Transfer
      }
    ]
  },
  { path: "*", component: NotFoundPage }
];

const router = new VueRouter({
  base: 'pos_admin',
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = !to.matched.some(record => record.meta.nonRequiresAuth);
  const isLoginPage = to.matched.some(record => record.meta.loginPage);
  if (requiresAuth && !store.state.isAuthenticated) {
    next('/login');
  }
  else if (isLoginPage && store.state.isAuthenticated) {
    next('/home');
  }

  next();
});

export default router